import { useCallback, useEffect, useMemo } from "react";
import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Button from "@/components/Form/Button/Button";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import ControlSelectCountry from "./ControlSelectCountry";
import {
  MotifErrorMessage,
  MotifProgressLoader,
  MotifButton,
} from "@/libs/@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import { useForm } from "react-hook-form";
import ControlSelect from "../../Claim/ClaimDetails/ControlSelect";
import ControlInputBox from "../../Creditor/CreditorSetup/Form/ControlInputBox";
import {
  useCreatePayeeTypeDataMutation,
  useEditPayeeTypeDataMutation,
  useLazyGetPayeeTypeSummaryDataApiDataQuery,
} from "@/features/distributions/steps/calculationStepReducer";
import ControlTextAreaWithCharLimit from "@/components/Form/InputBox/ControlTextAreaWithCharLimit";
import ContactSelect from "../../Claim/claimSetup/Creditor/Components/ContactFormFields/ContactSelect";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { countryRecordType } from "../../Creditor/CreditorSetup/type";
import Banner, { BannerElement } from "@/components/Banner/Banner";
import {
  MotifIcon,
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifLabel,
} from "@ey-xd/motif-react";
import ControlSelectState from "./ControlSelectState";
import { dateFunc } from "@/components/Functions/dateFunc";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import {
  COPY_BUTTON_VARIANT,
  getCommonCopyImg,
} from "@/components/Images/CommonImages";

import {
  ACCOUNT_NUMBER,
  ACH_CODE,
  ADDRESS1,
  ADDRESS2,
  CITY,
  COUNTRY,
  EMAIL,
  FAX,
  FIRST_NAME,
  IBAN_NUMBER,
  INSTITUTION_NUMBER,
  LAST_NAME,
  POSTAL_CODE,
  PREFIX,
  ROUTING_CODE,
  STATE,
  SWIFT_CODE,
  TRANSIT_NUMBER,
  BUSINESS_NAME,
} from "../../Creditor/CreditorSetup/Constants";
import { useLazyGetProvincesQuery } from "@/services/creditors/creditorsReducers";
import { useDispatch } from "react-redux";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import PaymentInputField from "../../Creditor/CreditorSetup/PaymentInputField";
import { useCase } from "@/features/case/use-case";
import { havingEditPermission, isCountryCanadaOrUS } from "@/utility/common";
import {
  CANCEL_BUTTON_VARIANT,
  SAVE_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
import { ActiveTabsOrder } from "@/menuData";
export default function PayeeTypeForm() {
  const { t } = useTranslation();
  const parameter = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const defaultPayeeLevel = searchParams.get("payeeLevel");
  const navigatedFrom = searchParams.get("navigatedFrom");
  const distributionId = searchParams.get("distributionId");
  const distributionName = searchParams.get("distributionName");

  const caseData = useCase();
  const [showTextProvince, setShowTextProvince] = useState(true);
  const PREFIX_OPTIONS_LIST = [
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.mr"),
      value: "Mr.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.ms"),
      value: "Ms.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.mrs"),
      value: "Mrs.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.miss"),
      value: "Miss.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.estateof"),
      value: "Estate of",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.other"),
      value: "other",
    },
  ];
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    setError,
    reset,
    formState: { errors, isDirty },
  } = useForm<any>({
    defaultValues: {
      payeeLevel: defaultPayeeLevel?.toString() === "0" ? "0" : "",
      name: "",
      nameFr: "",
      desc: "",
      prefix: "",
      firstName: "",
      lastName: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      postalCode: "",
      country: "",
      state: "",
      phoneNumber: "",
      businessName: "",
      fax: "",
    },
  });
  const [showContactsSection, setshowContactsSection] = useState(false);
  const [getProvinces, { isFetching: isStateListFetching }] =
    useLazyGetProvincesQuery();
  // const [getVotes, { data: votersData, isLoading, isFetching }]
  const [
    getSummary,
    { data: payeeTypeSummary, isLoading: payeeTypeSummaryLoading },
  ] = useLazyGetPayeeTypeSummaryDataApiDataQuery();
  const countryList = useSelector((state: any) => state.country.countryList);
  let { caseName } = useCase();
  const permissions = useSelector((state: any) => state.permissions);
  const { PayeeType } = permissions;
  const pageEditStatus = havingEditPermission(PayeeType) ? false : true;

  const [createPayeeType, { isLoading: payeeCreateLoading }] =
    useCreatePayeeTypeDataMutation();
  const [editPayeeType, { isLoading: payeeUpdateLoading }] =
    useEditPayeeTypeDataMutation();
  const [isDiscardVisible, setIsDiscardVisible] = useState(false);
  const [countryArray, setCountryArry] = useState([
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
  ]);

  const [stateListBycounrty, setStateListBycounrty] = useState([
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
  ]);
  const [PaymentDetailsOpen, setPaymentDetailsOpen] = useState(false);
  const [showField, setShowField] = useState<any>({});
  const [showToastSuccess, setShowToastSuccess] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setDiscardEditMode({ editMode: isDirty }));
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
    };
  }, [dispatch, isDirty]);
  const payeeLevel = watch("payeeLevel");

  const onChangeHandlerCountry = useCallback(
    async (
      index: number,
      countryId: string,
      onPageLoad?: boolean | undefined
    ) => {
      if (!countryId) {
        return;
      }
      const selectedCountry = countryArray.find((c) => c.value === countryId);
      const countryName = selectedCountry?.label || "";
      const IsCanadaOrUs = isCountryCanadaOrUS(countryName);
      if (IsCanadaOrUs) {
        setShowTextProvince(false);
      } else {
        setShowTextProvince(true);
        if (!onPageLoad) {
          setValue("state", "");
        }
        return;
      }
      if (
        (!payeeTypeSummary || payeeTypeSummary.countryId !== countryId) &&
        !onPageLoad
      ) {
        setValue("state", "");
      }

      //setValue("state", "");

      // @ts-ignore
      const responseApi = await getProvinces(countryId).unwrap();
      if (responseApi.length > 0) {
        let stateListBycounrty: { label: string; value: string }[] = [];
        // eslint-disable-next-line array-callback-return

        responseApi.forEach(
          (stateObj: { id: string; name: string; code: string }) => {
            stateListBycounrty.push({
              label: stateObj.code,
              value: stateObj.code,
            });
          }
        );

        setStateListBycounrty(stateListBycounrty);
      } else {
        setStateListBycounrty([]);
        setValue("stateoptions", "");
        if (!onPageLoad) {
          setValue("state", "");
        }
      }
    },

    [countryArray, getProvinces, payeeTypeSummary, setValue]
  );
  useEffect(() => {
    if (parameter?.payeeId) {
      getSummary(parameter?.payeeId);
    }
  }, [parameter?.payeeId, getSummary]);

  const defaultOption = useMemo(
    () => ({
      label: t("global.globalActions.optionDefault"),
      value: "",
    }),
    [t]
  );

  useEffect(() => {
    if (parameter?.payeeId && payeeTypeSummary) {
      if (Number(payeeTypeSummary?.payeeLevel) === 1) {
        reset({
          name: payeeTypeSummary?.name,
          nameFr: payeeTypeSummary?.nameFrench,
          payeeLevel: payeeTypeSummary?.payeeLevel.toString(),
          desc: payeeTypeSummary?.description,
          prefix: payeeTypeSummary?.prefix,
          firstName: payeeTypeSummary?.firstName,
          lastName: payeeTypeSummary?.lastName,
          businessName: payeeTypeSummary?.businessName,
          email: payeeTypeSummary?.email,
          address1: payeeTypeSummary?.address1,
          address2: payeeTypeSummary?.address2,
          city: payeeTypeSummary?.city,
          postalCode: payeeTypeSummary?.postalCode,
          country: payeeTypeSummary?.countryId,
          state: payeeTypeSummary?.provinceState,
          phoneNumber: payeeTypeSummary?.phone,
          fax: payeeTypeSummary?.fax,
          transitNumber: payeeTypeSummary?.transitNumber,
          ibanNumber: payeeTypeSummary?.ibanNumber,
          institutionNumber: payeeTypeSummary?.institutionNumber,
          routingCode: payeeTypeSummary?.routingCode,
          swiftCode: payeeTypeSummary?.swiftCode,
          achCode: payeeTypeSummary?.achCode,
          accountNumber: payeeTypeSummary?.accountNumber,
        });
      } else {
        reset({
          name: payeeTypeSummary?.name,
          nameFr: payeeTypeSummary?.nameFrench,
          payeeLevel: payeeTypeSummary?.payeeLevel.toString(),
          desc: payeeTypeSummary?.description,
        });
      }

      //payeeTypeSummary && onChangeHandlerCountry(0, payeeTypeSummary?.countryId);
    }
  }, [payeeTypeSummary, setValue, reset, parameter?.payeeId]);

  useEffect(() => {
    if (
      payeeTypeSummary &&
      countryArray.length > 1 &&
      payeeTypeSummary?.payeeLevel === 1
    ) {
      onChangeHandlerCountry(0, payeeTypeSummary?.countryId, true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payeeTypeSummary, countryArray]);

  useEffect(() => {
    if (payeeLevel === "1") setshowContactsSection(true);
    else setshowContactsSection(false);
  }, [payeeLevel]);

  const onSubmit = async (data: any) => {
    setShowToastSuccess("");
    if (data.payeeLevel === "0" && !data.name.trim()) {
      setError("name", {
        type: "required",
      });
      return;
    }

    if (
      data.payeeLevel === "1" &&
      (!data.name.trim() || !data.firstName.trim() || !data.lastName.trim())
    ) {
      if (!data.name.trim()) {
        setError("name", {
          type: "required",
        });
      }
      if (!data.firstName.trim()) {
        setError("firstName", {
          type: "required",
        });
      }
      if (!data.lastName.trim()) {
        setError("lastName", {
          type: "required",
        });
      }
      return;
    }

    let contactDetailsData = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      businessName: data?.businessName,
      prefix: data?.prefix,
      address1: data?.address1,
      address2: data?.address2,
      city: data?.city,
      postalCode: data?.postalCode,
      countryId: data.country || null,
      provinceState: data.state || null,
      phone: data.phoneNumber,
      fax: data?.fax,
      email: data?.email,
      transitNumber: data?.transitNumber,
      ibanNumber: data?.ibanNumber,
      institutionNumber: data?.institutionNumber,
      routingCode: data?.routingCode,
      swiftCode: data?.swiftCode,
      achCode: data?.achCode,
      accountNumber: data?.accountNumber,
    };

    let formData = {
      caseId: parameter?.caseId,
      name: data?.name,
      nameFrench: data?.nameFr,
      description: data?.desc,
      payeeLevel: Number(data?.payeeLevel),
      ...contactDetailsData,
    };

    let EditData = {
      id: parameter?.payeeId,
      name: data?.name,
      nameFrench: data?.nameFr,
      payeeLevel: Number(data?.payeeLevel),
      description: data?.desc,
      singlePayeeContactId: payeeTypeSummary?.singlePayeeContactId,
      ...contactDetailsData,
    };
    dispatch(setDiscardEditMode({ editMode: false }));

    if (parameter?.payeeId) {
      const response: any = await editPayeeType(EditData);
      if (response.hasOwnProperty("data")) {
        //@ts-ignore
        setShowToastSuccess(
          response?.data?.message ||
            t("pages.distributions.payeeType.PayeeUpdatedMessage")
        );
        setErrorMessage("");
        getSummary(parameter?.payeeId);
        reset(getValues(), { keepDirty: false });
      } else {
        dispatch(setDiscardEditMode({ editMode: true }));
        //@ts-ignore
        setErrorMessage(
          response.error?.data?.message ||
            t("global.globalNotifications.unExpectedError")
        );
      }
    } else {
      const response: any = await createPayeeType(formData);
      if (response.hasOwnProperty("data")) {
        //@ts-ignore
        setShowToastSuccess(
          response?.data?.message ||
            t("pages.distributions.payeeType.PayeeCreatedMessage")
        );
        setErrorMessage("");
        navigate(
          //@ts-ignore
          `/case/${parameter?.caseId}/configuration/payee/edit/${response?.data?.payeeTypeId}`
        );
      } else {
        dispatch(setDiscardEditMode({ editMode: true }));
        //@ts-ignore
        setErrorMessage(
          response.error?.data?.message ||
            t("global.globalNotifications.unExpectedError")
        );
      }
    }
  };
  useEffect(() => {
    if (countryList !== undefined) {
      // eslint-disable-next-line array-callback-return
      const countryOptions = countryList.map((record: countryRecordType) => {
        return {
          label: record.countryName,
          value: record.countryId,
        };
      });
      // setCountryArry(countryOptions);
      setCountryArry([defaultOption, ...countryOptions]);

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [countryList, defaultOption]);

  const handleViewIcon = (name: string) => {
    setShowField((prev: any) => ({ ...prev, [name]: !prev[name] }));
  };

  const bannerElement: BannerElement[] = [
    {
      label: "pages.distributions.payeeType.bannerDetails.label1",
      value:
        payeeTypeSummary?.payeeLevel === 1
          ? t("pages.distributions.payeeType.bannerDetails.case")
          : payeeTypeSummary?.payeeLevel === 0
          ? t("pages.distributions.payeeType.bannerDetails.creditor")
          : "-",
      elementKey: "caseID",
    },
    {
      label: "pages.distributions.payeeType.bannerDetails.label2",
      value:
        dateFunc(payeeTypeSummary?.lastUpdatedDate).formattedDateTime +
          " " +
          caseData?.abbreviation || "-",
      elementKey: "caseID",
    },
  ];
  const breadcrumbItems = parameter?.payeeId
    ? navigatedFrom === "distributionSteps" &&
      distributionId &&
      distributionName
      ? [
          {
            label: "External Submission",
            value: "10 New Creditor Submission",
            elementKey: "submission",
            text: caseName,
            url: `/case/${parameter?.caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
          },
          {
            label: "External Submission",
            value: "10 New Creditor Submission",
            elementKey: "submission",
            text: distributionName,
            url: `/case/${parameter?.caseId}/distribution/${distributionId}?activeTab=1`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
          },
          {
            label: "External Submission",
            value: "10 New Creditor Submission",
            elementKey: "submission",
            text: payeeTypeSummary?.name,
            url: `/case/${parameter?.caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
            disabled: true,
          },
        ]
      : [
          {
            label: "External Submission",
            value: "10 New Creditor Submission",
            elementKey: "submission",
            text: caseName,
            url: `/case/${parameter?.caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
          },
          {
            label: "External Submission",
            value: "10 New Creditor Submission",
            elementKey: "submission",
            text: payeeTypeSummary?.name,
            url: `/case/${parameter?.caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
            disabled: true,
          },
        ]
    : [
        {
          label: "External Submission",
          value: "10 New Creditor Submission",
          elementKey: "submission",
          text: caseName,
          url: `/case/${parameter?.caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          label: "External Submission",
          value: "10 New Creditor Submission",
          elementKey: "submission",
          text: t("pages.distributions.payeeType.createNewPayeeType"),
          url: `/case/${parameter?.caseId}/?activeTab=${ActiveTabsOrder.DISTRIBUTION}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
          disabled: true,
        },
      ];

  const copiedToClipBoard = () => {
    const firstName = getValues(FIRST_NAME);
    const lastName = getValues(LAST_NAME);
    const address1 = getValues(ADDRESS1);
    const address2 = getValues(ADDRESS2);
    const city = getValues(CITY);
    const state = getValues(STATE);
    const postalCode = getValues(POSTAL_CODE);
    const country = getValues(COUNTRY);
    const countryLabel =
      countryArray.find((c) => c.value === country)?.label || "";
    const stateLabel =
      stateListBycounrty.find((s) => s.value === country)?.label || state;
    const namePart = [firstName, lastName].filter(Boolean).join(" ").trim();
    const addressPart = [address1, address2].filter(Boolean).join(" ").trim();
    const cityStatePostalPart = [city, stateLabel, postalCode]
      .filter(Boolean)
      .join(", ")
      .trim();
    const countryPart = countryLabel ? countryLabel.trim() : null;
    const addressParts = [
      namePart,
      addressPart,
      cityStatePostalPart,
      countryPart,
    ];
    const formattedAddress = addressParts
      .filter((part) => part && part.trim() !== "")
      .join("\n");

    navigator.clipboard
      .writeText(formattedAddress)
      .then(() => {
        setShowToastSuccess(t("global.globalNotifications.copiedToClipboard"));
      })
      .catch((err) => {
        console.error(t("global.globalNotifications.copiedToClipboardError"));
      });
  };

  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />

      <Banner
        bannerName={"pages.distributions.payeeType.bannerDetails.title"}
        bannerNameValue={payeeTypeSummary?.name}
        elements={bannerElement}
      />
      {showToastSuccess && (
        <div className="pad-t-20">
          <NotificationGrid
            show={true}
            message={showToastSuccess}
            type={"success"}
          />
        </div>
      )}
      {errorMessage && (
        <div className="pad-t-20">
          <NotificationGrid show={true} message={errorMessage} type={"error"} />
        </div>
      )}
      <div className="motif-container case-summary-form pad-v-20 mar-t-20">
        <div className="motif-body1-default-regular page-title">
          {t("pages.distributions.payeeType.createPayeeTitle")}
        </div>
        <div className="motif-body2-default-regular page-description">
          {t("pages.distributions.payeeType.createPayeeDescription")}
        </div>
      </div>
      {payeeTypeSummaryLoading ? (
        <MotifProgressLoader show />
      ) : (
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{ marginBottom: "80px" }}
        >
          <div className={`motif-container main-container pad-t-20 `}>
            <div className="motif-row">
              <div className="motif-col-lg-4">
                <div className="form-field">
                  <ControlInputBox
                    // @ts-ignore
                    name={"name"}
                    control={control}
                    isTextArea={false}
                    label={"pages.distributions.payeeType.formLabels.name"}
                    required={true}
                    showLabel={true}
                    disabled={pageEditStatus}
                  />
                  {errors["name"] && errors["name"].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.distributions.payeeType.validationMessages.nameRequired"
                      )}
                    </MotifErrorMessage>
                  )}
                </div>
              </div>
              <div className="motif-col-lg-4">
                <div className="form-field">
                  <ControlInputBox
                    // @ts-ignore
                    name={"nameFr"}
                    control={control}
                    isTextArea={false}
                    label={
                      "pages.distributions.payeeType.formLabels.nameFrench"
                    }
                    showLabel={true}
                    disabled={pageEditStatus}
                  />
                </div>
              </div>
              <div className="motif-col-lg-4">
                <div className="form-field">
                  <ControlSelect
                    name={"payeeLevel"}
                    //@ts-ignore
                    control={control}
                    disabled={pageEditStatus}
                    required={true}
                    showLabel={true}
                    //@ts-ignore
                    readonly={true}
                    label={
                      "pages.distributions.payeeType.formLabels.payeeLevel"
                    }
                    //@ts-ignore
                    placeholder={"placeholder"}
                    options={[
                      {
                        label: t(
                          "pages.distributions.payeeType.payeeLevelOptions.label1"
                        ),
                        value: "",
                      },
                      {
                        label: t(
                          "pages.distributions.payeeType.payeeLevelOptions.label2"
                        ),
                        value: "0",
                      },
                      {
                        label: t(
                          "pages.distributions.payeeType.payeeLevelOptions.label3"
                        ),
                        value: "1",
                      },
                    ]}
                  />
                  {errors["payeeLevel"] &&
                    errors["payeeLevel"].type === "required" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.payeeType.validationMessages.payeeRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                </div>
              </div>
            </div>
            <div className="motif-row mar-b-20">
              <div className="motif-col-lg-4 mar-t-20">
                <ControlTextAreaWithCharLimit
                  name={"desc"}
                  control={control}
                  required={false}
                  isTextArea={true}
                  label={"pages.distributions.payeeType.formLabels.description"}
                  showLabel={true}
                  readonly={pageEditStatus}
                />
              </div>
            </div>
            {showContactsSection ? (
              <div className="heading">
                <div className="motif-row">
                  <div className="motif-col-lg-11">
                    <h1 className="mar-t-0">
                      {t(
                        "pages.distributions.payeeType.formLabels.contactDetails"
                      )}
                    </h1>
                  </div>
                  <div className="motif-col-lg-1">
                    <CommonTooltipWrapper
                      tooltipTitle={t("global.globalActions.copyToClipboard")}
                    >
                      <MotifButton
                        size="small"
                        variant={COPY_BUTTON_VARIANT}
                        onClick={copiedToClipBoard}
                        type="button"
                      >
                        {getCommonCopyImg()}
                      </MotifButton>
                    </CommonTooltipWrapper>
                  </div>
                </div>
                <div className="motif-row section-border">
                  <div className="motif-col-lg-4 mar-t-20">
                    <ContactSelect
                      label={"pages.distributions.payeeType.formLabels.prefix"}
                      name={PREFIX}
                      options={PREFIX_OPTIONS_LIST}
                      control={control}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={FIRST_NAME}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.firstName"
                      }
                      showLabel={true}
                      required={showContactsSection ? true : false}
                      disabled={pageEditStatus}
                    />
                    {errors[t(FIRST_NAME)]?.type === "required" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.payeeType.validationMessages.firstNameRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={LAST_NAME}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.lastName"
                      }
                      showLabel={true}
                      required={showContactsSection ? true : false}
                      disabled={pageEditStatus}
                    />
                    {errors[t(LAST_NAME)]?.type === "required" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.distributions.payeeType.validationMessages.lastNameRequired"
                        )}
                      </MotifErrorMessage>
                    )}
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={BUSINESS_NAME}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.businessName"
                      }
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={EMAIL}
                      control={control}
                      isTextArea={false}
                      label={"pages.distributions.payeeType.formLabels.email"}
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={"phoneNumber"}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.phoneNumber"
                      }
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={FAX}
                      control={control}
                      isTextArea={false}
                      label={"pages.distributions.payeeType.formLabels.fax"}
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={ADDRESS1}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.address1"
                      }
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={ADDRESS2}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.address2"
                      }
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlSelectCountry
                      name={COUNTRY}
                      control={control}
                      required={false}
                      showLabel={true}
                      label={"pages.distributions.payeeType.formLabels.country"}
                      options={countryArray}
                      setValue={setValue}
                      getValues={getValues}
                      onChangeHandlerCountry={onChangeHandlerCountry}
                      filter={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    {!showTextProvince && (
                      <div className="form-field">
                        {/**@ts-ignore */}
                        <ControlSelectState
                          name={STATE}
                          control={control}
                          required={false}
                          showLabel={true}
                          label={
                            "pages.distributions.payeeType.formLabels.provinceState"
                          }
                          options={stateListBycounrty}
                          filter={true}
                          disabled={pageEditStatus || isStateListFetching}
                        />
                        {/**@ts-ignore */}
                        <div className="hide">
                          <ControlInputBox
                            name={"stateoptions"}
                            control={control}
                            required={false}
                            isTextArea={false}
                            label={""}
                            showLabel={false}
                            disabled={pageEditStatus}
                          />
                        </div>
                        {isStateListFetching && (
                          <MotifLabel>
                            {t("global.globalNotifications.loadingMessage")}
                          </MotifLabel>
                        )}
                      </div>
                    )}
                    {showTextProvince && (
                      <div className="form-field">
                        <ControlInputBox
                          // @ts-ignore
                          name={STATE}
                          control={control}
                          isTextArea={false}
                          label={
                            "pages.distributions.payeeType.formLabels.provinceState"
                          }
                          showLabel={true}
                          disabled={pageEditStatus}
                        />
                      </div>
                    )}
                  </div>
                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={CITY}
                      control={control}
                      isTextArea={false}
                      label={"pages.distributions.payeeType.formLabels.city"}
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>

                  <div className="motif-col-lg-4 mar-t-20">
                    <ControlInputBox
                      // @ts-ignore
                      name={POSTAL_CODE}
                      control={control}
                      isTextArea={false}
                      label={
                        "pages.distributions.payeeType.formLabels.postalCode"
                      }
                      showLabel={true}
                      disabled={pageEditStatus}
                    />
                  </div>
                </div>

                <div className="motif-container ccwp_claim_summary_white_accordian mar-t-20 pad-0">
                  <MotifAccordion
                    onClose={() => setPaymentDetailsOpen(false)}
                    onOpen={() => setPaymentDetailsOpen(true)}
                    style={{
                      flex: "1",
                    }}
                    alignIconRight={true}
                    useChevronIcon={true}
                    className="mar-b-20"
                    open={PaymentDetailsOpen}
                  >
                    {/*  Payment details start */}

                    <MotifAccordionTrigger>
                      <div className="ccwp_claim_summary_white">
                        <label>
                          {t(
                            "pages.distributions.payeeType.formLabels.paymentDetails"
                          )}
                        </label>
                      </div>
                    </MotifAccordionTrigger>
                    <MotifAccordionContent className="sub-accordian payment-details-wrapper">
                      <div className="motif-row">
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.institutionNumber"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={INSTITUTION_NUMBER}
                            disabled={pageEditStatus}
                          />
                        </div>
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.transitNumber"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={TRANSIT_NUMBER}
                            disabled={pageEditStatus}
                          />
                        </div>
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.accountNumber"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={ACCOUNT_NUMBER}
                            disabled={pageEditStatus}
                          />
                        </div>
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.IBANNumber"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={IBAN_NUMBER}
                            disabled={pageEditStatus}
                          />
                        </div>
                      </div>
                      <div className="motif-row pad-t-20">
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.routingCode"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={ROUTING_CODE}
                            disabled={pageEditStatus}
                          />
                        </div>
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.SWIFTCode"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={SWIFT_CODE}
                            disabled={pageEditStatus}
                          />
                        </div>
                        <div className="motif-col-lg-3">
                          <div className="title">
                            {t(
                              "pages.distributions.payeeType.formLabels.ACHCode"
                            )}
                          </div>
                          <PaymentInputField
                            control={control}
                            showField={showField}
                            handleViewIcon={handleViewIcon}
                            name={ACH_CODE}
                            disabled={pageEditStatus}
                          />
                        </div>
                      </div>
                    </MotifAccordionContent>
                  </MotifAccordion>
                </div>
              </div>
            ) : (
              ""
            )}

            {!pageEditStatus && (
              <div className="button-container sticky-footer">
                <Button
                  label={t("global.globalActions.save")}
                  type={
                    payeeCreateLoading || payeeUpdateLoading
                      ? "loader"
                      : "submit"
                  }
                  variant={SAVE_BUTTON_VARIANT}
                  disabled={payeeCreateLoading || payeeUpdateLoading}
                  loading={payeeCreateLoading || payeeUpdateLoading}
                />
                <Button
                  type="button"
                  label={t("global.globalActions.cancel")}
                  variant={CANCEL_BUTTON_VARIANT}
                  className="cancelBtn"
                  onClickHandler={() => {
                    if (isDirty) {
                      setIsDiscardVisible(true);
                      dispatch(setDiscardEditMode({ editMode: false }));
                    } else {
                      if (
                        navigatedFrom === "distributionSteps" &&
                        distributionId &&
                        distributionName
                      ) {
                        navigate(
                          `/case/${parameter?.caseId}/distribution/${distributionId}?activeTab=1`
                        );
                      } else {
                        navigate(
                          `/case/${parameter?.caseId}?activeTab=${ActiveTabsOrder.DISTRIBUTION}`
                        );
                      }
                    }
                  }}
                />
              </div>
            )}
          </div>
          <br></br>
        </form>
      )}
      <ConfirmationModal
        isVisible={isDiscardVisible}
        setIsVisible={setIsDiscardVisible}
        cancelBtnApproveHandler={() => {
          if (
            navigatedFrom === "distributionSteps" &&
            distributionId &&
            distributionName
          ) {
            navigate(
              `/case/${parameter?.caseId}/distribution/${distributionId}?activeTab=1`
            );
          } else {
            navigate(
              `/case/${parameter?.caseId}?activeTab=${ActiveTabsOrder.DISTRIBUTION}`
            );
          }
        }}
        cancelBtnRejectHandler={() => {
          dispatch(setDiscardEditMode({ editMode: true }));

          setIsDiscardVisible(false);
        }}
      />
    </>
  );
}
